var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrowUpSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24ZM18.0469 10.0781C18.4875 10.5188 18.4875 11.2312 18.0469 11.6672C17.6063 12.1031 16.8938 12.1078 16.4578 11.6672L13.1297 8.33906V18.375C13.1297 18.9984 12.6281 19.5 12.0047 19.5C11.3813 19.5 10.8797 18.9984 10.8797 18.375V8.33906L7.55156 11.6672C7.11094 12.1078 6.39844 12.1078 5.9625 11.6672C5.52656 11.2266 5.52187 10.5141 5.9625 10.0781L11.2031 4.82812C11.6438 4.3875 12.3562 4.3875 12.7922 4.82812L18.0469 10.0781Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowUpSolid);
export default __webpack_public_path__ + "static/media/circle-arrow-up-solid.60821cb92d5998b9e6d3f9acb802d997.svg";
export { ForwardRef as ReactComponent };